import { useMemo } from 'react';
import { useGetPackagesQuery } from '../api';
/**
 * Hook to get a document package for a specific id.
 *
 * @param projectId the project id that the package belongs to.
 * @param packageId the package id to fetch.
 *
 * @returns an object with a document package, loading state, error state and error object.
 */
export const usePackage = (projectId, packageId) => {
    const { data: packages = [], isLoading, isError, error } = useGetPackagesQuery({ projectId });
    const pkg = useMemo(() => packages.find((p) => p.id === packageId), [packageId, packages]);
    return useMemo(() => ({
        pkg,
        isLoading,
        isError,
        error,
    }), [error, isError, isLoading, pkg]);
};
